import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faCalendar as faCalendarRegular } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCircleInfo as faCircleInfoRegular } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCopy as faCopyRegular } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { faTrashCan as faTrashCanRegular } from '@fortawesome/pro-regular-svg-icons/faTrashCan';
import { faXmark as faXmarkRegular } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faArrowLeftFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowLeftFromBracket';
import { faArrowLeftLong } from '@fortawesome/pro-solid-svg-icons/faArrowLeftLong';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons/faArrowUpRight';
import { faArrowsRepeat } from '@fortawesome/pro-solid-svg-icons/faArrowsRepeat';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faBaby } from '@fortawesome/pro-solid-svg-icons/faBaby';
import { faBabyCarriage } from '@fortawesome/pro-solid-svg-icons/faBabyCarriage';
import { faBadgePercent } from '@fortawesome/pro-solid-svg-icons/faBadgePercent';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBanSmoking } from '@fortawesome/pro-solid-svg-icons/faBanSmoking';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBoltLightning } from '@fortawesome/pro-solid-svg-icons/faBoltLightning';
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook';
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons/faBookOpen';
import { faBrain } from '@fortawesome/pro-solid-svg-icons/faBrain';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBurger } from '@fortawesome/pro-solid-svg-icons/faBurger';
import { faBus } from '@fortawesome/pro-solid-svg-icons/faBus';
import { faCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCarSide } from '@fortawesome/pro-solid-svg-icons/faCarSide';
import { faChair } from '@fortawesome/pro-solid-svg-icons/faChair';
import { faChartColumn } from '@fortawesome/pro-solid-svg-icons/faChartColumn';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChild } from '@fortawesome/pro-solid-svg-icons/faChild';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faCoins } from '@fortawesome/pro-solid-svg-icons/faCoins';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faDesktop } from '@fortawesome/pro-solid-svg-icons/faDesktop';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFaceGrinStars } from '@fortawesome/pro-solid-svg-icons/faFaceGrinStars';
import { faFaceViewfinder } from '@fortawesome/pro-solid-svg-icons/faFaceViewfinder';
import { faFamilyPants } from '@fortawesome/pro-solid-svg-icons/faFamilyPants';
import { faFile } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFileLock } from '@fortawesome/pro-solid-svg-icons/faFileLock';
import { faFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faFingerprint } from '@fortawesome/pro-solid-svg-icons/faFingerprint';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandHoldingHeart } from '@fortawesome/pro-solid-svg-icons/faHandHoldingHeart';
import { faHeadphones } from '@fortawesome/pro-solid-svg-icons/faHeadphones';
import { faHeartPulse } from '@fortawesome/pro-solid-svg-icons/faHeartPulse';
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faHospital } from '@fortawesome/pro-solid-svg-icons/faHospital';
import { faIcons } from '@fortawesome/pro-solid-svg-icons/faIcons';
import { faIdBadge } from '@fortawesome/pro-solid-svg-icons/faIdBadge';
import { faIdCard } from '@fortawesome/pro-solid-svg-icons/faIdCard';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLanguage } from '@fortawesome/pro-solid-svg-icons/faLanguage';
import { faLeftFromBracket } from '@fortawesome/pro-solid-svg-icons/faLeftFromBracket';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons/faLocationDot';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMessage } from '@fortawesome/pro-solid-svg-icons/faMessage';
import { faMessageQuestion } from '@fortawesome/pro-solid-svg-icons/faMessageQuestion';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faMoneyBillTransfer } from '@fortawesome/pro-solid-svg-icons/faMoneyBillTransfer';
import { faMoneyBillTrendUp } from '@fortawesome/pro-solid-svg-icons/faMoneyBillTrendUp';
import { faMoneyBills } from '@fortawesome/pro-solid-svg-icons/faMoneyBills';
import { faParking } from '@fortawesome/pro-solid-svg-icons/faParking';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faPercent } from '@fortawesome/pro-solid-svg-icons/faPercent';
import { faPersonCane } from '@fortawesome/pro-solid-svg-icons/faPersonCane';
import { faPiggyBank } from '@fortawesome/pro-solid-svg-icons/faPiggyBank';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faRepeat } from '@fortawesome/pro-solid-svg-icons/faRepeat';
import { faRightFromBracket } from '@fortawesome/pro-solid-svg-icons/faRightFromBracket';
import { faRightLeft } from '@fortawesome/pro-solid-svg-icons/faRightLeft';
import { faSack } from '@fortawesome/pro-solid-svg-icons/faSack';
import { faSeedling } from '@fortawesome/pro-solid-svg-icons/faSeedling';
import { faShapes } from '@fortawesome/pro-solid-svg-icons/faShapes';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons/faShieldHalved';
import { faShieldHeart } from '@fortawesome/pro-solid-svg-icons/faShieldHeart';
import { faShieldKeyhole } from '@fortawesome/pro-solid-svg-icons/faShieldKeyhole';
import { faShieldPlus } from '@fortawesome/pro-solid-svg-icons/faShieldPlus';
import { faShieldSlash } from '@fortawesome/pro-solid-svg-icons/faShieldSlash';
import { faSpa } from '@fortawesome/pro-solid-svg-icons/faSpa';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faSuitcaseRolling } from '@fortawesome/pro-solid-svg-icons/faSuitcaseRolling';
import { faSun } from '@fortawesome/pro-solid-svg-icons/faSun';
import { faSyringe } from '@fortawesome/pro-solid-svg-icons/faSyringe';
import { faTags } from '@fortawesome/pro-solid-svg-icons/faTags';
import { faTaxi } from '@fortawesome/pro-solid-svg-icons/faTaxi';
import { faTicketSimple } from '@fortawesome/pro-solid-svg-icons/faTicketSimple';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons/faTrashCan';
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import { faUtensils } from '@fortawesome/pro-solid-svg-icons/faUtensils';
import { faWandSparkles } from '@fortawesome/pro-solid-svg-icons/faWandSparkles';
import { faWeightScale } from '@fortawesome/pro-solid-svg-icons/faWeightScale';
import { faWheelchairMove } from '@fortawesome/pro-solid-svg-icons/faWheelchairMove';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

library.add(
  faUser,
  faIdCard,
  faFamilyPants,
  faPercent,
  faLanguage,
  faQuestion,
  faFileLines,
  faLock,
  faChevronRight,
  faArrowUpRight,
  faCheck,
  faCopyRegular,
  faTrashCanRegular,
  faEyeSlash,
  faEye,
  faCircleExclamation,
  faLeftFromBracket,
  faCreditCard,
  faCircleInfoRegular,
  faMinus,
  faPlus,
  faArrowLeftLong,
  faPencil,
  faHome,
  faUtensils,
  faSeedling,
  faCoins,
  faSparkles,
  faTags,
  faRightLeft,
  faLocationDot,
  faShieldHalved,
  faChevronDown,
  faChevronUp,
  faBaby,
  faChild,
  faBuilding,
  faFingerprint,
  faBell,
  faDownload,
  faUpload,
  faFileLock,
  faFilePdf,
  faPiggyBank,
  faCalendarRegular,
  faXmarkRegular,
  faExclamation,
  faXmark,
  faInfo,
  faCircleCheck,
  faCircleInfo,
  faCircleXmark,
  faMoneyBillTrendUp,
  faMoneyBills,
  faShieldPlus,
  faShieldKeyhole,
  faStar,
  faWandSparkles,
  faMagnifyingGlass,
  faKey,
  faUserPlus,
  faArrowLeftFromBracket,
  faCalendar,
  faMessage,
  faRightFromBracket,
  faBadgePercent,
  faFile,
  faTrashCan,
  faArrowsRotate,
  faFaceViewfinder,
  faArrowRight,
  faIcons,
  faBan,
  faSack,
  faIdBadge,
  faBus,
  faFacebook,
  faLinkedin,
  faInstagram,
  faMessageQuestion,
  faRepeat,
  faReceipt,
  faShieldSlash,
  faHospital,
  faMoneyBillTransfer,
  faSun,
  faParking,
  faDesktop,
  faTicketSimple,
  faBookOpen,
  faSpa,
  faHeartPulse,
  faPersonCane,
  faGraduationCap,
  faHandHoldingHeart,
  faShapes,
  faBabyCarriage,
  faFaceGrinStars,
  faAward,
  faBook,
  faBrain,
  faBurger,
  faCarSide,
  faChair,
  faHeadphones,
  faTaxi,
  faBoltLightning,
  faSuitcaseRolling,
  faSyringe,
  faBanSmoking,
  faWeightScale,
  faWheelchairMove,
  faShieldHeart,
  faArrowsRepeat,
  faChartColumn,
  faFilter,
  faWhatsapp
);
